import * as service from './service'
export default {
  namespace: 'indexesCitySelect',
  state: {
    selectedCity: null,

    // 定位城市
    locationCity: {}
  },
  effects: {
    * cities ({ payload }, { call }) {
      return yield call(service.cities, { payload })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
